import React from 'react';
import { color, font, radius, space, tone as tones, weight } from '../theme';
import Icon, { IconName } from './Icon';

// An explanatory strip in a page's flow: info (soft blue, e.g. the transitional government)
// or warning (e.g. data frozen until the site moves to a new Knesset)
const Notice = ({ tone = 'info', icon = 'alert', title, children, style }: {
  tone?: 'info' | 'warning';
  icon?: IconName;
  title?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  const c = tone === 'info' ? { fg: color.primaryInk, bg: color.primarySoft } : tones.warning;
  return (
    <div role="note" style={{
      display: 'flex', alignItems: 'flex-start', gap: space.md, padding: `${space.md + 2}px ${space.lg}px`,
      borderRadius: title ? radius.xl : radius.lg, background: c.bg, color: c.fg, ...style,
    }}>
      <span style={{ display: 'flex', flexShrink: 0, marginTop: 1 }}><Icon name={icon} size={title ? 22 : 18} strokeWidth={2} /></span>
      <div style={{ display: 'flex', flexDirection: 'column', gap: space.xs }}>
        {title && <div style={{ fontSize: font.body, fontWeight: weight.bold }}>{title}</div>}
        <div style={{ fontSize: font.small, lineHeight: 1.5 }}>{children}</div>
      </div>
    </div>
  );
};

export default Notice;
